import React from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'antd';
import ImagemPesquisarProtocol from 'assets/img/protocolo.svg';
import InputText from 'components/InputText';
import TitlePage from 'components/TituloPage';
import Captcha from 'components/Captcha';
import { fetchBuscarFormularioPorLocalizador } from 'store/fetchActions/fetchFormulario';
import { fetchSetReloadCaptcha } from 'store/fetchActions/fetchApp';
import { validarExibirErrosCampos, changeInput, changeDocument } from 'utils/formUtils';
import { ID_CAPTCHA, USER_ENTERED_CAPTCHA_CODE } from 'utils/consts';
import { publicRoot, detalharRequerimentoContribuinte } from 'routes/paths';
import { formatterProtocoloNull, formatterProtocoloFrontToBack } from 'utils/formatter/protocolo';
import { altImagemProtocolo } from 'utils/acessibilidade';
import { validationsProtocoloSearch } from 'utils/validate/protocolo';
import { descricaoProtocolo, successSubmit, finallySubmit } from './protocolo';
import * as S from './styles';
import * as Style from 'components/Style';

export default function Protocolo() {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: formatterProtocoloNull(),
  });

  const onChange = event => {
    changeInput(event, setValue, errors, setError);
  };

  const onSubmit = data => {
    dispatch(fetchSetReloadCaptcha(false));
    if (validarCampos(data)) {
      const { documento, localizador, captchaId, userEnteredCaptchaCode } = formatterProtocoloFrontToBack(data);

      dispatch(fetchBuscarFormularioPorLocalizador(localizador, documento, captchaId, userEnteredCaptchaCode))
        .then(() => {
          successSubmit(localizador, documento);
          history.push(detalharRequerimentoContribuinte);
        })
        .catch(() => dispatch(fetchSetReloadCaptcha(true)))
        .finally(() => finallySubmit());
    }
  };

  const validarCampos = data => {
    return validarExibirErrosCampos(data, validationsProtocoloSearch, setError);
  };

  const onSendValidation = e => {
    localStorage.setItem(ID_CAPTCHA, e.captchaId);
    localStorage.setItem(USER_ENTERED_CAPTCHA_CODE, e.userEnteredCaptchaCode?.toUpperCase());
    dispatch(handleSubmit(onSubmit));
  };

  return (
    <S.Page>
      <TitlePage textTitle={'CONSULTAR REQUERIMENTO'} backPage={publicRoot} />
      <Style.GlobalCard>
        <Row>
          <Col xs={20} sm={16} md={12} lg={8} xl={5}>
            <S.labelInputs>{descricaoProtocolo}</S.labelInputs>
            <InputText
              label="* Protocolo"
              name="protocolo"
              errors={errors}
              placeholder={'Protocolo'}
              control={control}
              onChange={onChange}
            />
            <InputText
              label="* CPF/CNPJ"
              name="documento"
              errors={errors}
              placeholder={'CPF/CNPJ'}
              control={control}
              onChange={e => onChange(changeDocument(e, 'documento'))}
            />
            <Captcha
              onSendCaptcha={onSendValidation}
              onValidade={() => validarCampos(getValues())}
              buttonLabel="Pesquisar"
            />
          </Col>
          <S.Imagem
            src={ImagemPesquisarProtocol}
            title="Imagem Pesquisa Protocolo"
            alt={altImagemProtocolo}
            data-testid="imagemPesquisaProtocolo"
          />
        </Row>
      </Style.GlobalCard>
    </S.Page>
  );
}
